import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import NotificationContext from '../NotificationContext';

const BookingForm = () => {
    const [technicians, setTechnicians] = useState([]);
    const [services, setServices] = useState([]);
    const [searchPincode, setSearchPincode] = useState('');
    const [selectedServiceId, setSelectedServiceId] = useState('');
    const [formData, setFormData] = useState({
        technicianId: '',
        serviceId: '',
        scheduledDateTime: '',
        customerNotes: ''
    });
    const { showNotification } = useContext(NotificationContext);

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const serviceRes = await axios.get('https://local-technician-finder-backend.onrender.com/api/services');
                setServices(serviceRes.data);
            } catch (err) {
                console.error(err);
                showNotification('Error fetching services.', 'error');
            }
        };
        fetchServices();
    }, [showNotification]);

    useEffect(() => {
        const fetchFilteredTechnicians = async () => {
            if (!searchPincode || !selectedServiceId) {
                setTechnicians([]);
                setFormData(prev => ({ ...prev, technicianId: '' }));
                return;
            }

            try {
                const selectedService = services.find(s => s._id === selectedServiceId);
                if (!selectedService) return;

                const url = `https://local-technician-finder-backend.onrender.com/api/technicians?pincode=${searchPincode}&serviceName=${selectedService.name}`;
                const techRes = await axios.get(url);
                setTechnicians(techRes.data);
                if (techRes.data.length === 0) {
                    setFormData(prev => ({ ...prev, technicianId: '' }));
                }
            } catch (err) {
                console.error(err);
                showNotification('Error fetching filtered technicians.', 'error');
                setTechnicians([]);
                setFormData(prev => ({ ...prev, technicianId: '' }));
            }
        };

        fetchFilteredTechnicians();
    }, [searchPincode, selectedServiceId, services, showNotification]);

    const handlePincodeChange = (e) => {
        setSearchPincode(e.target.value);
        setSelectedServiceId('');
        setFormData(prev => ({ ...prev, serviceId: '', technicianId: '' }));
    };

    const handleServiceChange = (e) => {
        setSelectedServiceId(e.target.value);
        setFormData(prev => ({ ...prev, serviceId: e.target.value, technicianId: '' }));
    };

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

    const onSubmit = async e => {
        e.preventDefault();
        const token = localStorage.getItem('token');
        if (!token) {
            showNotification('Please log in to make a booking.', 'error');
            return;
        }

        try {
            await axios.post('https://local-technician-finder-backend.onrender.com/api/bookings', formData, {
                headers: {
                    'x-auth-token': token
                }
            });
            showNotification('Booking created successfully!', 'success');
            setFormData({
                technicianId: '',
                serviceId: '',
                scheduledDateTime: '',
                customerNotes: ''
            });
            setSearchPincode('');
            setSelectedServiceId('');
        } catch (err) {
            console.error(err.response.data);
            showNotification(err.response.data.msg || 'Booking failed.', 'error');
        }
    };

    return (
        <div className="container">
            <h1>Create New Booking</h1>
            <div className="row">
                <div className="col-md-6">
                    <div className="card mb-3">
                        <h2>Find Your Technician</h2>
                        <div className="form-group">
                            <label className="form-label">Enter Pincode:</label>
                            <input
                                type="text"
                                value={searchPincode}
                                onChange={handlePincodeChange}
                                placeholder="e.g., 123456"
                                className="form-control"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Select Service:</label>
                            <select name="serviceId" value={selectedServiceId} onChange={handleServiceChange} className="form-control" required>
                                <option value="">Select Service</option>
                                {services.map(service => (
                                    <option key={service._id} value={service._id}>
                                        {service.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {searchPincode && selectedServiceId && technicians.length === 0 && (
                            <div className="card mt-3" style={{ textAlign: 'center', padding: '10px' }}>
                                <p>No technicians found for pincode {searchPincode} offering the selected service.</p>
                            </div>
                        )}
                    </div>
                </div>
                <div className="col-md-6">
                    <form onSubmit={onSubmit} className="form-container">
                        <h2>Book Your Service</h2>
                        <div className="form-group">
                            <label className="form-label">Technician:</label>
                            <select name="technicianId" value={formData.technicianId} onChange={onChange} className="form-control" required>
                                <option value="">Select Technician</option>
                                {technicians.map(tech => (
                                    <option key={tech._id} value={tech.userId._id}>
                                        {tech.firstName} {tech.lastName} ({tech.pincode})
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label className="form-label">Scheduled Date/Time:</label>
                            <input
                                type="datetime-local"
                                name="scheduledDateTime"
                                value={formData.scheduledDateTime}
                                onChange={onChange}
                                className="form-control"
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label className="form-label">Notes:</label>
                            <textarea
                                name="customerNotes"
                                value={formData.customerNotes}
                                onChange={onChange}
                                placeholder="Any specific instructions or details?"
                                className="form-control"
                            ></textarea>
                        </div>
                        <input type="submit" value="Book Now" className="btn" />
                    </form>
                </div>
            </div>
        </div>
    );
};

export default BookingForm;